export default {
    pageName: 'High temperature',
    search: {
        title: '',
        placeholder: 'Search by Location'
    },
    header: {
        full: 'Location'
    }
}
